import React from 'react';
import { Divider, Form, Icon, Header } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import RichTextEditor from '../../RichTextEditor';
import Metadata from '../Metadata';
import PermissionsManager from '../../PermissionsManager';

const details = ({ status, obj, language, onChange }) => {
  return (
    <div>
      <Header as="h3">Bloc contenu de l'événement</Header>
      <Form.Field>
        <Form.Input
          label="Titre"
          placeholder="Titre"
          id="name"
          value={obj.translations[language.code].name}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Form.Field>
        <Form.Input
          label="Date(s)"
          placeholder="Date(s)"
          id="date"
          value={obj.translations[language.code].date}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Form.Field>
        <Form.Input
          label="Introduction"
          placeholder="Introduction"
          id="introduction"
          value={obj.translations[language.code].introduction}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Form.Field>
        <label>Contenu</label>
        <RichTextEditor
          id="content"
          value={obj.translations[language.code].content}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Form.Group widths="equal">
        <Form.Input
          placeholder="Texte du bouton"
          id="cta_text"
          fluid
          label="Label du bouton"
          value={obj.translations[language.code].cta_text}
          onChange={(e) => onChange(e, language.code)}
        />
        <Form.Input
          placeholder="https://..."
          id="cta_url"
          fluid
          label="Adresse cible"
          value={obj.translations[language.code].cta_url}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Group>
      <Metadata obj={obj} language={language} onChange={onChange} />
      <Header as="h3">Bloc info de l'événement</Header>
      <Form.Field>
        <Form.Input
          label="Tags"
          placeholder="Tags"
          id="tags"
          value={obj.translations[language.code].tags}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Form.Field>
        <Form.Input
          label="Description"
          placeholder="Description"
          id="description"
          value={obj.translations[language.code].description}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Header as="h3">Bloc Instagram</Header>
      <Form.Field>
        <Form.Input
          label="Titre de la section"
          placeholder="Titre de la section"
          id="section_instagram_title"
          value={obj.translations[language.code].section_instagram_title || ''}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Header as="h3">Bloc Push Facebook (facultatif)</Header>
      <p>
        Ce bloc est facultatif. Si aucun titre n'est renseigné, il ne sera pas
        affiché sur la page.
      </p>
      <Form.Field>
        <Form.Input
          label="Titre du bloc Push Facebook"
          placeholder="Titre du bloc Push Facebook"
          id="fb_title"
          value={obj.translations[language.code].fb_title || ''}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Form.Field>
        <Form.Input
          label="Date de l'événement"
          placeholder="Date de l'événement"
          id="fb_date"
          value={obj.translations[language.code].fb_date || ''}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Form.Field>
        <Form.Input
          label="Lieu de l'événement"
          placeholder="Lieu de l'événement"
          id="fb_location"
          value={obj.translations[language.code].fb_location || ''}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Form.Group widths="equal">
        <Form.Field>
          <Form.Input
            label="Label du bouton"
            placeholder="Label du bouton"
            id="fb_cta_label"
            value={obj.translations[language.code].fb_cta_label || ''}
            onChange={(e) => onChange(e, language.code)}
          />
        </Form.Field>
        <Form.Field>
          <Form.Input
            label="URL du bouton"
            placeholder="URL du bouton"
            id="fb_cta_url"
            value={obj.translations[language.code].fb_cta_url || ''}
            onChange={(e) => onChange(e, language.code)}
          />
        </Form.Field>
      </Form.Group>
      {!status.isNew ? (
        <PermissionsManager
          hasPermissions={[
            'create_event_detail_link',
            'update_event_detail_link',
            'delete_event_detail_link',
          ]}
        >
          <Link
            to={`/events/${obj.id}/links/${obj.translations[language.code].id}`}
            floated="right"
            className="ui button olive"
          >
            <Icon name="chain" /> Liens additionnels
          </Link>
        </PermissionsManager>
      ) : (
        <div>
          <Divider hidden={true} />
          L'accès aux liens additionnels sera disponible une fois l'élément
          enregistré
        </div>
      )}
    </div>
  );
};

export default details;



// WEBPACK FOOTER //
// ./src/components/form/event/details.js